import { loadIndexes, sortCreaturesByNc } from '@data/indexes';
import type { Creature } from '@data/schemas';
import { normalize } from '@features/search';
import { html } from 'lit';
import { buildHref } from '../router';

export async function renderBestiairePage(): Promise<unknown> {
  const idx = await loadIndexes();
  const list = sortCreaturesByNc(idx.creaturesAll);

  const matches = (c: Creature, q: string): boolean =>
    normalize(`${c.nom} ${c.type ?? ''} ${c.taille ?? ''}`).includes(q);

  const render = (c: Creature) => html`
    <a href=${buildHref('creature', { id: c.id })} class="list-card" data-tilt>
      <span class="list-card-badge list-card-badge-danger">NC ${c.nc ?? '-'}</span>
      <span class="list-card-title">${c.nom}</span>
      <span class="list-card-sub">
        ${c.taille ?? ''}${c.taille && c.type ? ' · ' : ''}${c.type ?? ''}
      </span>
      <span class="list-card-meta">PV ${c.pv} · DEF ${c.def} · ATT ${c.att}</span>
    </a>
  `;

  return html`
    <div class="list-page">
      <header class="list-page-header">
        <h1 class="list-page-title" data-morph data-morph-duration="1500">Bestiaire</h1>
        <p class="list-page-subtitle">${list.length} creatures, triees par niveau de challenge (NC).</p>
      </header>
      <cof2-search-grid
        .items=${list}
        .predicate=${matches}
        .renderItem=${render}
        placeholder="Rechercher une creature..."
      ></cof2-search-grid>
    </div>
  `;
}
